<template>
	<BaseCmsPage v-slot="{page}">
		<Body class="faq center-title" />
		<CmsIntroContainer :page="page">
			<template #h1>
				<h1 v-if="page?.seo_h1">{{ page.seo_h1 }}</h1>
			</template>
		</CmsIntroContainer>
		
		<div class="wider-wrapper faq-wrapper">
			<BaseFaqCategories :fetch="{limit: 30, code: 'faq_basic'}" v-slot="{items}">
				<template v-if="items?.length">
					<template v-for="item in items" :key="item.id">
						<BaseFaqQuestions :fetch="{category_position: item.position_h}"  v-slot="{items}">
							<template v-if="items?.length">
								<CmsFaqItem v-for="faq_item in items" :key="faq_item.id" :item="faq_item" />
							</template>
						</BaseFaqQuestions>
					</template>
				</template>
			</BaseFaqCategories>

			<CmsShare />
		</div>
	</BaseCmsPage>
</template>

<script setup>
</script>

<style lang="less" scoped>
	.faq-wrapper{
		width: 950px; padding: 40px 0 100px 0;
		@media (max-width: @l){width: 900px;}
		@media (max-width: @t){padding: 30px 0 75px; margin: 0 170px; width: auto;}
		@media (max-width: @tp){padding: 25px 0 65px; margin: 0 15px;}
		@media (max-width: @m){padding: 15px 0 40px;}
	}
</style>

<style lang="less">
	.faq .share{
		padding-left: 29px;
		@media (max-width: @m){padding-left: 23px; padding-top: 15px;}
	}
</style>
